import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { CRMAuthProvider } from "@/context/CRMAuthContext";
import Home from "@/pages/Home";
import Signup from "@/pages/Signup";
import Login from "@/pages/Login";
import DashboardOverview from "@/pages/DashboardOverview";
import Projects from "@/pages/Projects";
import Orders from "@/pages/Orders";
import Invoices from "@/pages/Invoices";
import Messages from "@/pages/Messages";
import Settings from "@/pages/Settings";
import Support from "@/pages/Support";
import ConsultationBooking from "@/pages/ConsultationBooking";
import ServiceDetail from "@/pages/ServiceDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import ConsultationSuccess from "@/pages/ConsultationSuccess";
import Portfolio from "@/pages/Portfolio";
import AdminDashboard from "@/pages/AdminDashboard";
import LeadMagnetPopup from "@/components/LeadMagnetPopup";
import CRMIntroPopup from "@/components/CRMIntroPopup";
import FloatingCRMButton from "@/components/FloatingCRMButton";
import { Toaster } from "@/components/ui/sonner";

// CRM Pages
import CRMLogin from "@/pages/CRM/CRMLogin";
import CRMDashboard from "@/pages/CRM/CRMDashboard";
import CRMLeads from "@/pages/CRM/CRMLeads";
import CRMDeals from "@/pages/CRM/CRMDeals";
import CRMContacts from "@/pages/CRM/CRMContacts";
import CRMTeam from "@/pages/CRM/CRMTeam";
import CRMActivities from "@/pages/CRM/CRMActivities";
import CRMSettings from "@/pages/CRM/CRMSettings";
import CRMPricing from "@/pages/CRM/CRMPricing";
import CRMCheckout from "@/pages/CRM/CRMCheckout";
import CRMSubscriptionSuccess from "@/pages/CRM/CRMSubscriptionSuccess";
import CRMIntegrations from "@/pages/CRM/CRMIntegrations";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <CRMAuthProvider>
              <Routes>
                {/* Public Routes */}
                <Route path="/" element={<Home />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/login" element={<Login />} />
                <Route path="/book-consultation" element={<ConsultationBooking />} />
                <Route path="/consultation/success" element={<ConsultationSuccess />} />
                <Route path="/services/:serviceId" element={<ServiceDetail />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/checkout/success" element={<CheckoutSuccess />} />
                <Route path="/portfolio" element={<Portfolio />} />
                <Route path="/admin" element={<AdminDashboard />} />
                
                {/* Dashboard Routes */}
                <Route path="/dashboard" element={<DashboardOverview />} />
                <Route path="/dashboard/overview" element={<DashboardOverview />} />
                <Route path="/dashboard/projects" element={<Projects />} />
                <Route path="/dashboard/projects/:projectId" element={<Projects />} />
                <Route path="/dashboard/orders" element={<Orders />} />
                <Route path="/dashboard/invoices" element={<Invoices />} />
                <Route path="/dashboard/messages" element={<Messages />} />
                <Route path="/dashboard/settings" element={<Settings />} />
                <Route path="/dashboard/support" element={<Support />} />

                {/* CRM SaaS Routes */}
                <Route path="/crm/pricing" element={<CRMPricing />} />
                <Route path="/crm/checkout" element={<CRMCheckout />} />
                <Route path="/crm/subscription/success" element={<CRMSubscriptionSuccess />} />
                <Route path="/crm/login" element={<CRMLogin />} />
                <Route path="/crm/dashboard" element={<CRMDashboard />} />
                <Route path="/crm/leads" element={<CRMLeads />} />
                <Route path="/crm/deals" element={<CRMDeals />} />
                <Route path="/crm/contacts" element={<CRMContacts />} />
                <Route path="/crm/team" element={<CRMTeam />} />
                <Route path="/crm/activities" element={<CRMActivities />} />
                <Route path="/crm/integrations" element={<CRMIntegrations />} />
                <Route path="/crm/settings" element={<CRMSettings />} />
              </Routes>
              
              {/* Global Lead Magnet Popup */}
              <LeadMagnetPopup />
              
              {/* CRM Product Introduction Popup */}
              <CRMIntroPopup />
              
              {/* Floating CRM Button */}
              <FloatingCRMButton />
            </CRMAuthProvider>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
